import { Navigate } from "react-router-dom";
import { Show } from "@clerk/react";
import { useMe } from "@/context/MeContext";
import { Loader2 } from "lucide-react";

export const Loading = ({ label = "Loading" }) => (
  <div className="flex min-h-[40vh] items-center justify-center gap-2 text-muted-foreground" data-testid="loading-state">
    <Loader2 className="h-4 w-4 animate-spin" /> {label}
  </div>
);

export default function RequireAuth({ roles, children }) {
  const { me, loading } = useMe();
  return (
    <>
      <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
      <Show when="signed-in">
        {loading ? <Loading /> : roles && (!me || !roles.includes(me.role)) ? (
          <div className="mx-auto max-w-xl px-6 py-24" data-testid="access-denied">
            <h1 className="text-3xl">This area is restricted</h1>
            <p className="mt-3 text-muted-foreground">Your account doesn't have access to this workspace.</p>
          </div>
        ) : children}
      </Show>
    </>
  );
}
